import { Reveal } from "../components/Reveal";

export const PageHero = ({ kicker, title, desc }) => (
  <section className="relative bg-brand-coal pt-40 pb-16 sm:pb-20 overflow-hidden">
    <div className="absolute inset-0 noise-overlay opacity-[0.06] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal y={20}>
        <div className="flex items-center gap-3">
          <span className="h-[2px] w-12 bg-brand-red" />
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-white/60">{kicker}</span>
        </div>
      </Reveal>
      <Reveal y={28} delay={0.08}>
        <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold uppercase tracking-tight text-white leading-[1.02] max-w-3xl">
          {title}
        </h1>
      </Reveal>
      {desc && (
        <Reveal y={24} delay={0.16}>
          <p className="mt-5 max-w-2xl text-base text-white/55 leading-relaxed">{desc}</p>
        </Reveal>
      )}
    </div>
  </section>
);
